export default function lang(path, object) {

	let current_lang = $('body').data('lang');

	if (typeof object !== 'undefined' && object !== null) {
		if (typeof object === 'string') {
			object = JSON.parse(object);
		}
		// return object[current_lang][path];
		return resolve(path, object[current_lang]);
	}
	else {
		return `Object for ${path} is undefined`
	}

}
function resolve(path, obj) {
	return path.split('.').reduce(function(prev, curr) {
		return prev ? prev[curr] : null
	}, obj || self)
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/lang.js